import React from 'react'
import { SvgIcon } from '../svg-icon'

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {React.defaultProps}
 */
const defaultProps = {
    viewBoxSize: 24
}

/**
 * Stateless function representing a light top icon.
 *
 * @function
 * @param {Object} [props] - The component properties
 * @returns {JSX.Element} React component markup
 *
 * @see SvgIcon
 * @example
 * <LightTopIcon width={24} />
 */
const LightTopIcon = props => (
    <SvgIcon {...props}>
        <path
            d={`M15 8.02C15 8.01 15 8.01 15 8V5C15 3.9 14.1 3 13 3H11C9.9 3 9 3.9 9 5V8C9 8.01 9 8.01 9
            8.02C7.79 8.93 7 10.37 7 12C7 14.76 9.24 17 12 17C14.76 17 17 14.76 17 12C17 10.37 16.21 8.93
            15 8.02ZM11 5H13V7.1C12.68 7.04 12.34 7 12 7C11.66 7 11.32 7.04 11 7.1V5ZM13 21C13 21.55 12.55
            22 12 22C11.45 22 11 21.55 11 21V20C11 19.45 11.45 19 12 19C12.55 19 13 19.45 13 20V21ZM19.07
            17.66C19.46 18.05 19.46 18.69 19.07 19.07C18.68 19.46 18.04 19.46 17.66 19.07L16.95 18.36C16.56
            17.97 16.56 17.33 16.95 16.95C17.34 16.57 17.98 16.56 18.36 16.95L19.07 17.66ZM21 11C21.55 11 22
            11.45 22 12C22 12.55 21.55 13 21 13H20C19.45 13 19 12.55 19 12C19 11.45 19.45 11 20 11H21ZM4
            11C4.55 11 5 11.45 5 12C5 12.55 4.55 13 4 13H3C2.45 13 2 12.55 2 12C2 11.45 2.45 11 3 11H4ZM5.64
            16.95C6.03 16.56 6.67 16.56 7.05 16.95C7.43 17.34 7.44 17.98 7.05 18.36L6.34 19.07C5.95 19.46
            5.31 19.46 4.93 19.07C4.54 18.68 4.54 18.04 4.93 17.66L5.64 16.95Z`}
        />
    </SvgIcon>
)

LightTopIcon.defaultProps = defaultProps

export { LightTopIcon }
